export default __webpack_public_path__ + "static/media/errorIcon.11d2942f.svg";